/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useContext,
  useCallback,
  useMemo,
  useRef,
} from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Teams,
} from '../../utils/api';
import { ARMcontext } from '../../utils/context/context';
import { useInputValue } from '../../utils/hooks/useInputValue';
import {
  LabelsWrapper,
  LabelsContainer,
  TextContainer,
  AlertContainer,
  Oval,
  HideContainer,
} from './wellness/styles';
import {
  Exams,
  Scorecard,
  Health,
  Velocity,
  Workloads,
  Wellness,
  Accountability,
  KeyMetrics,
  ActionItems,
  Leaderboard,
  PlayerExams,
  PlayerKeyMetrics,
  PlayerScorecard,
  PlayerHealth,
  PlayerVelocity,
  PlayerWorkloads,
  PlayerWellness,
  PlayerAccountability,
} from './';
import PlayersTeamsDashboardPage from './dashboard';
import { PlayerDashboard } from './playerPortal';

import {
  Routes,
  Route,
  useParams,
  useLocation,
  useNavigate,
  useNavigationType,
  Outlet,
} from 'react-router-dom';
import {
  ContainerLeft,
  ButtonWrapper,
  ContainerRight,
  DropdownWrapper,
  PlayersContainer,
  PlayersDataSection,
  PlayersFilterSection,
  MessageText,
} from './styles';
import {
  Navbar,
  PreviusTab,
  FiltersContainer,
  PowerDropdown,
  Tabs,
  InputComponent,
  LargeButton,
  Modal,
  EditTeam,
  PlayerBanner,
} from '../../components';
import { TeamDataResponse } from '../../interfaces/Results';
import { TeamsCacheKey } from '../../utils/constants/keyCache';
import { shouldClearSelectedPlayerForUrl } from '../../utils/helpers/playersRoute';

/** `navigate(..., { state })` from dashboard activity → player Key Metrics */
type PlayersNavigateState = {
  exitTo?: string;
  selectPlayer?: { name?: string } & Record<string, unknown>;
};

const DefaultPlayers = [
  { title: 'Players', lenght: 50, value: '' },
  { title: 'Pitchers', lenght: 20, value: 'Pitchers' },
  { title: 'Catchers', lenght: 30, value: 'Catchers' },
];

const DefaultAlerts = [
  { title: 'Alerts', lenght: 10, color: '', alert: false, value: '' },
  { title: 'Pain', lenght: 30, color: '#f84958e6', alert: true, value: 'Pain' },
];

const TeamPills = [
  {
    title: 'Dashboard',
    url: 'dashboard',
  },
  {
    title: 'Key Metrics',
    url: 'keyMetrics',
  },
  {
    title: 'Exams',
    url: 'exams',
  },
  {
    title: 'Accountability',
    url: 'accountability',
  },
];

const PlayerPills = [
  {
    title: 'Dashboard',
    url: 'playerDashboard',
  },
  {
    title: 'Key Metrics',
    url: 'keyMetrics',
  },
  {
    title: 'Exams',
    url: 'exams',
  },
  {
    title: 'Accountability',
    url: 'accountability',
  },

  /*
  {
    title: 'Wellness',
    url: 'wellness',
  },
  */
];

const toastPromise = {
  pending: 'The file is being generated',
  success: 'File downloaded! 🔥',
  error: 'There was an error on our side!',
};

export default () => {
  const {
    teamMemo,
    selectedTeam,
    selectedPlayer,
    HandleSelectedTeam,
    HandleSelectedPlayer,
    AddNewTeams,
    user,
    ToggleReload,
    RemoveSelectedPlayer,
  } = useContext(ARMcontext);
  const [defaultPlayers, useDefaultPlayers] = useState<Array<any>>(DefaultPlayers);
  const [defaultAlerts, useDefaultAlerts] = useState<Array<any>>(DefaultAlerts);
  const [isDownloadDisabled, useisDownloadDisabled] = useState(false);
  const [players, usePlayers] = useState<any>(defaultPlayers[0]);
  const [alerts, useAlerts] = useState<any>(DefaultAlerts[0]);
  const [isFirstLoad, setFirstLoad] = useState(true);
  const [modal, useModal] = useState<boolean>(false);
  const [debouncedFilterValue, setDebouncedFilterValue] = useState('');
  const filterPlayer = useInputValue('', 'search');
  const location = useLocation();
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const prevLocationKeyRef = useRef<string | null>(null);
  const Team = new Teams();

  const playersNavState = (location.state ?? null) as PlayersNavigateState | null;
  const pendingSelectPlayer =
    playersNavState?.selectPlayer?.name ? playersNavState.selectPlayer : null;
  const displayPlayer = selectedPlayer?.name ? selectedPlayer : pendingSelectPlayer;
  const [keyScaleModal, setKeyScaleModal] = useState(false);
  const [currentPath, setCurrentPath] = useState(location.pathname);
  const debounce = useCallback((func: Function, delay: number) => {
    let timeoutId: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  }, []);

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      setDebouncedFilterValue(value);
    }, 300),
    []
  );

  useEffect(() => {
    debouncedSearch(filterPlayer.value);
  }, [filterPlayer.value, debouncedSearch]);

  useEffect(() => {
    if (location.pathname === '/players/actionItems') filterPlayer.onChange({ target: { value: '' } });
  }, [location])

  /**
   * Activity table passes `selectPlayer` in location.state so the first paint uses player
   * mode (avoids team Key Metrics mounting). Persist to context and strip from history.
   */
  useLayoutEffect(() => {
    const st = (location.state ?? null) as PlayersNavigateState | null;
    if (!st?.selectPlayer?.name) return;
    HandleSelectedPlayer(st.selectPlayer);
    const nextState: { exitTo?: string } = {};
    if (st.exitTo != null) nextState.exitTo = st.exitTo;
    navigate(
      { pathname: location.pathname, search: location.search },
      { replace: true, state: Object.keys(nextState).length ? nextState : undefined },
    );
  }, [
    location.key,
    location.pathname,
    location.search,
    location.state,
    HandleSelectedPlayer,
    navigate,
  ]);

  /**
   * If the URL is a team-only tab (e.g. dashboard) but a player is still selected, clear
   * selection so the team shell renders (browser Back, stale localStorage).
   */
  useEffect(() => {
    if (shouldClearSelectedPlayerForUrl(location.pathname, selectedPlayer?.name)) {
      RemoveSelectedPlayer();
    }
  }, [location.pathname, location.key, selectedPlayer?.name, RemoveSelectedPlayer]);

  /**
   * Browser Back/Forward: some team and player views share the same base path.
   * Popping to a prior team history entry restores `location` without `state.exitTo`;
   * context can still have `selectedPlayer` — clear so the team table renders.
   * Skip the first `location.key` (MemoryRouter reports `POP` on initial mount).
   */
  useEffect(() => {
    const sharedTeamPlayerPrefixes = ['/players/keyMetrics', '/players/exams', '/players/accountability'];
    const key = location.key;
    const prevKey = prevLocationKeyRef.current;
    if (prevKey === null) {
      prevLocationKeyRef.current = key;
      return;
    }
    if (prevKey === key) return;
    prevLocationKeyRef.current = key;
    if (navigationType !== 'POP') return;
    if (!sharedTeamPlayerPrefixes.some(prefix => location.pathname.startsWith(prefix))) return;
    const st = location.state as { exitTo?: string } | null | undefined;
    if (st != null && typeof st === 'object' && st.exitTo != null && String(st.exitTo).length > 0) {
      return;
    }
    if (!selectedPlayer?.name) return;
    RemoveSelectedPlayer();
  }, [
    navigationType,
    location.key,
    location.pathname,
    location.state,
    selectedPlayer?.name,
    RemoveSelectedPlayer,
  ]);

  // Full page load: refresh teams from GET /api/v2/team so position-count labels (e.g. Pitchers (N))
  // match the server; teamMemo alone comes from localStorage and can be stale.
  useEffect(() => {
    void FetchTeams(true);
  }, []);


  useEffect(() => {
    if (!isFirstLoad && (selectedTeam._id || selectedTeam.__name)) {
      FetchTeams();
    }
  }, [selectedTeam._id, selectedTeam.__name]);

  function BuildPlayersFilter(activeTeam = selectedTeam) {
    const buildPlayers = [
      {
        title: 'Players',
        lenght: activeTeam?.totalPlayers?.toString() || activeTeam?.players?.length?.toString() ,
        value: '',
      },
      {
        title: 'Pitchers',
        lenght: activeTeam?.pitchers?.toString() || '0',
        value: 'Pitchers',
      },
      {
        title: 'Catchers',
        lenght: activeTeam?.catchers?.toString() || '0',
        value: 'Catchers',
      },
      {
        title: 'Infielders',
        lenght: activeTeam?.infielders?.toString() || '0',
        value: 'Infielders',
      },
      {
        title: 'Outfielders',
        lenght: activeTeam?.outfielders?.toString() || '0',
        value: 'Outfielders',
      },
    ];
    usePlayers(prev => {
      const activePlayer = buildPlayers.find(el => prev.title === el.title);
      if (activePlayer && (prev.title !== activePlayer.title || prev.lenght !== activePlayer.lenght)) {
        return {
          title: activePlayer.title,
          lenght: activePlayer.lenght,
          value: activePlayer.value,
        };
      }
      return prev;
    });
    useDefaultPlayers(buildPlayers);
  }

  const ChangeTeam = useCallback((activeTeam = selectedTeam) => {
    HandleSelectedTeam(activeTeam);
  }, [selectedTeam, HandleSelectedTeam]);

  const ChangePlayers = useCallback((selectedOption) => {
    usePlayers(selectedOption);
  }, []);


  function HandleTeamStatus(): void {
    HandleSelectedTeam(teamMemo[0]);
  }

  function HandlePlayersStatus(): void {
    usePlayers(defaultPlayers[0]);
  }

  function ChangeAlerts(selectedOption: any): void {
    useAlerts(selectedOption);
  }

  function HandleAlertStatus(): void {
    useAlerts(defaultAlerts[0]);
  }

  async function FetchTeams(isEdit=false, isCacheable=true): Promise<void> {
    let fetchedTeams: any[] = [];
    if(isEdit){
      let res: TeamDataResponse;
      if(isCacheable){
        res = await Team.ExecuteCacheRequest({
          cacheKey: TeamsCacheKey,
          queryFn: Team.GetMyTeams,
        });
      } else {
        res = await Team.ExecuteCacheRequest({
          isForceDelete: true,
          cacheKey: TeamsCacheKey,
          queryFn: Team.GetMyTeams,
        });
      }

      if (res.status) {
        const allValues = {
          pitchers: res.data.meta.players.all.pitchers,
          catchers: res.data.meta.players.all.catchers,
          infielders: res.data.meta.players.all.infielders,
          outfielders: res.data.meta.players.all.outfielders,
        };
        const AllPlayers = {
          ...allValues,
          age: [],
          color: '#007AFF',
          badge: 'ALL',
          name: 'All Players',
          totalPlayers: res.data.meta.players.total,
          __name: 'All Players',
          __organization: 'ARM CARE',
          __organizationToStr: 'ARM CARE',
        };
        AddNewTeams([AllPlayers, ...(res.data.teams ?? [])]);
        fetchedTeams = [...(res.data.teams ?? [])];
      }
    } else {
      fetchedTeams = [...(teamMemo ?? [])];
    }
    BuildPlayersFilter(fetchedTeams.filter(el => el._id === selectedTeam._id)[0]);
    setFirstLoad(false)
  }

  async function RecallMyTeams(){
    await FetchTeams(true);
  }

  function HandleEditTeam(value = !modal) {
    console.log('Click en Edit Team, abriendo modal:', value);
    useModal(value);
    if (!value) {
      ToggleReload();
      FetchTeams(true);
    }
  }

  async function HandleOrgCsv(onlyAllData?: boolean) {
    useisDownloadDisabled(true);

    if (selectedTeam.badge === 'ALL') {
      await toast.promise(Team.GetTeamCSV('', false, onlyAllData), toastPromise);
    } else {
      await toast.promise(Team.GetTeamCSV(selectedTeam._id, true, onlyAllData), toastPromise);
    }
    useisDownloadDisabled(false);
  }

  const renderPlayer = useMemo(() => {
    if (displayPlayer?.name) {
      return <SelectedPlayerRouter filterPlayer={debouncedFilterValue} playersGroup={players.value} />
    }
    return (
      <PlayersRouter
        isFirstLoad={isFirstLoad}
        filterPlayer={debouncedFilterValue}
        playersGroup={players.value === undefined ? '' : players.value}
        useDefaultAlerts={useDefaultAlerts}
        alerts={alerts}
        useAlerts={useAlerts}
        keyScaleModal={keyScaleModal}
        setKeyScaleModal={setKeyScaleModal}
      />
    );
  }, [
    isFirstLoad,
    debouncedFilterValue,
    players,
    alerts,
    keyScaleModal,
    displayPlayer,
    location.state,
  ]);

  return (
    <>
      <ToastContainer />
      <Navbar />
      <PreviusTab />
      <FiltersContainer cy-data="players_filters">
        {displayPlayer?.name ? (
          <>
            <PlayerBanner selectedPlayer={displayPlayer} />
          </>
        ) : (
          <PlayersContainer data-cy="players-filters">
            <ContainerLeft>
              <DropdownWrapper>
                <PowerDropdown
                  primaryTitle={selectedTeam.name}
                  badge={selectedTeam?.initials || selectedTeam.badge}
                  colorBadge={selectedTeam.color}
                  picture={selectedTeam.picture}
                  search={true}
                  status={true}
                  handleStatus={HandleTeamStatus}
                  onClick={ChangeTeam}
                  dataArray={teamMemo}
                  mPadding="4px 0 4px 10px;z-index:1000"
                  mWidth="308px"
                  disabled={isFirstLoad}
                />
              </DropdownWrapper>
              <DropdownWrapper>
                <PowerDropdown
                  primaryTitle={players.title}
                  visibleLenght={players.lenght}
                  search={false}
                  status={true}
                  handleStatus={HandlePlayersStatus}
                  onClick={ChangePlayers}
                  dataArray={defaultPlayers}
                  mPadding="4px 0 4px 10px;z-index:1000"
                />
              </DropdownWrapper>
              <DropdownWrapper className='message-wrapper'>
                <MessageText>
                  Only players with data are shown
                </MessageText>
              </DropdownWrapper>
              <HideContainer>
                <DropdownWrapper>
                  {window.location.href.includes('/players/exams') && (
                    <PowerDropdown
                      primaryTitle={alerts.title}
                      visibleLenght={alerts.lenght}
                      search={false}
                      status={true}
                      color={alerts.color}
                      handleStatus={HandleAlertStatus}
                      onClick={ChangeAlerts}
                      dataArray={defaultAlerts}
                      mPadding="4px 0 4px 10px"
                    />
                  )}
                </DropdownWrapper>
              </HideContainer>
            </ContainerLeft>
            <ContainerRight>
              {!(selectedTeam.badge === 'ALL') ? (
                <>
                  {user.role === 'org-admin' || user.data.isAdmin ? (
                    <>
                      <InputComponent responsive="770px" dynamicSearch={filterPlayer} animateWidth="30%" placeholder="Search" />

                      <ButtonWrapper>
                        <LargeButton
                          title="EDIT TEAM"
                          lColor="var(--SecondaryBlue);"
                          rColor="var(--PrimaryBlue);"
                          icon="save"
                          responsive="770px"
                          callback={HandleEditTeam}
                        />
                      </ButtonWrapper>
                    </>
                  ) : (
                    <InputComponent responsive="770px" dynamicSearch={filterPlayer} animateWidth="50%" placeholder="Search" />
                  )}
                </>
              ) : (
                <InputComponent responsive="770px" dynamicSearch={filterPlayer} animateWidth="50%" placeholder="Search" />
              )}
              <ButtonWrapper>
                <LargeButton
                  title="TEAM XLSX"
                  lColor="var(--SecondaryGreen);"
                  rColor="var(--PrimaryGreen);"
                  icon="excel"
                  responsive="770px"
                  callback={() => HandleOrgCsv()}
                  disabled={isDownloadDisabled}
                />
                <LargeButton
                  title="TEAM CSV"
                  lColor="var(--SecondaryGreen);"
                  rColor="var(--PrimaryGreen);"
                  icon="excel"
                  responsive="770px"
                  xMargin="0 0 0 10px"
                  callback={() => HandleOrgCsv(true)}
                  disabled={isDownloadDisabled}
                />
              </ButtonWrapper>
            </ContainerRight>
          </PlayersContainer>
        )}
      </FiltersContainer>

      <PlayersDataSection>
        <FiltersContainer bColor="var(--BackgroundGrey)">
          <PlayersFilterSection>
            <Tabs dataArray={displayPlayer?.name ? PlayerPills : TeamPills} url={'/players'} />
            {window.location.href.includes('players/wellness') && (
              <LabelsWrapper>
                <TextContainer>WELLNESS ALERT</TextContainer>
                <LabelsContainer>
                  <AlertContainer>
                    <Oval size={'8'} color={'yellow'} />
                    <span> Watch</span>
                  </AlertContainer>
                  <AlertContainer>
                    <Oval size={'8'} color={'red'} />
                    <span> Warning</span>
                  </AlertContainer>
                  <AlertContainer>
                    <Oval size={'8'} color={'blue'} />
                    <span> Medical</span>
                  </AlertContainer>
                </LabelsContainer>
              </LabelsWrapper>
            )}
          </PlayersFilterSection>
        </FiltersContainer>
        <Routes>
          <Route path={`:playersId/*`} element={renderPlayer} />
        </Routes>
      </PlayersDataSection>
      {modal && (
        <Modal title="Edit Team" margin="6vh auto 200px auto">
          <EditTeam HandleEditTeam={HandleEditTeam} RecallMyTeams={RecallMyTeams} />
        </Modal>
      )}
    </>
  );
};

type PlayersViewId =
  | 'dashboard'
  | 'exams'
  | 'health'
  | 'scorecard'
  | 'velocityTest'
  | 'playerWorkloads'
  | 'accountability'
  | 'wellness'
  | 'leaderboard'
  | 'keyMetrics'
  | 'actionItems';

type PlayersRouterProps = {
  isFirstLoad: boolean;
  filterPlayer: any;
  playersGroup: string;
  useDefaultAlerts: any;
  alerts: any;
  useAlerts: any;
  keyScaleModal?: any;
  setKeyScaleModal?: any;
};

const playersViewRenderers: Record<PlayersViewId, (props: PlayersRouterProps) => React.ReactElement> = {
  dashboard: ({ playersGroup, filterPlayer }) => (
    <PlayersTeamsDashboardPage
      playersGroup={playersGroup}
      playerNameSearch={filterPlayer?.value ?? filterPlayer ?? ''}
    />
  ),
  exams: ({ isFirstLoad, playersGroup, filterPlayer, alerts, useAlerts, useDefaultAlerts }) => (
    <Exams
      isFirstLoad={isFirstLoad}
      playersGroup={playersGroup}
      playerNameSearch={filterPlayer}
      alerts={alerts}
      useAlerts={useAlerts}
      useDefaultAlerts={useDefaultAlerts}
    />
  ),
  health: () => <Health />,
  scorecard: ({ playersGroup, filterPlayer }) => (
    <Scorecard playersGroup={playersGroup} playerNameSearch={filterPlayer.value} />
  ),
  velocityTest: () => <Velocity />,
  playerWorkloads: () => <Workloads />,
  accountability: ({ isFirstLoad, playersGroup, filterPlayer }) => (
    <Accountability
      isFirstLoad={isFirstLoad}
      playersGroup={playersGroup}
      playerNameSearch={filterPlayer}
    />
  ),
  wellness: ({ isFirstLoad, playersGroup, filterPlayer }) => (
    <Wellness
      isFirstLoad={isFirstLoad}
      playersGroup={playersGroup}
      playerNameSearch={filterPlayer}
    />
  ),
  leaderboard: ({ playersGroup, filterPlayer }) => (
    <Leaderboard playersGroup={playersGroup} playerNameSearch={filterPlayer.value} />
  ),
  keyMetrics: ({ isFirstLoad, playersGroup, keyScaleModal, filterPlayer, setKeyScaleModal }) => (
    <KeyMetrics
      isFirstLoad={isFirstLoad}
      playersGroup={playersGroup}
      keyScaleModal={keyScaleModal}
      playerNameSearch={filterPlayer}
      setKeyScaleModal={setKeyScaleModal}
    />
  ),
  actionItems: ({ isFirstLoad, playersGroup, filterPlayer }) => (
    <ActionItems isFirstLoad={isFirstLoad} playersGroup={playersGroup} playerNameSearch={filterPlayer} />
  ),
};

const PlayersRouter = ({
  isFirstLoad,
  filterPlayer,
  playersGroup,
  useDefaultAlerts,
  alerts,
  useAlerts,
  keyScaleModal,
  setKeyScaleModal,
}: PlayersRouterProps) => {
  const { playersId } = useParams<{ playersId?: string }>();

  const viewRenderer =
    playersId && (playersViewRenderers as Record<string, (props: PlayersRouterProps) => React.ReactElement>)[playersId];

  return <>{viewRenderer ? viewRenderer({ isFirstLoad, filterPlayer, playersGroup, useDefaultAlerts, alerts, useAlerts, keyScaleModal, setKeyScaleModal }) : <></>}</>;
};
const SelectedPlayerRouter = ({ playersGroup, filterPlayer }) => {
  const { playersId } = useParams() as any;
  const { selectedPlayer } = useContext(ARMcontext);
  return (
    <>
      {playersId === 'playerDashboard' ? (
        <PlayerDashboard playerId={selectedPlayer._id} />
      ) : playersId === 'exams' ? (
        <PlayerExams />
      ) : playersId === 'keyMetrics' ? (
        <PlayerKeyMetrics />
      ) : playersId === 'health' ? (
        <PlayerHealth />
      ) : playersId === 'scorecard' ? (
        <PlayerScorecard />
      ) : playersId === 'velocityTest' ? (
        <PlayerVelocity />
      ) : playersId === 'playerWorkloads' ? (
        <PlayerWorkloads />
      ) : playersId === 'accountability' ? (
        <PlayerAccountability playersGroup={playersGroup} playerNameSearch={filterPlayer.value} />
      ) : playersId === 'wellness' ? (
        <PlayerWellness />
      ) : playersId === 'leaderboard' ? (
        <Leaderboard playersGroup={playersGroup} playerNameSearch={filterPlayer.value} />
      ) : (
        <></>
      )}
    </>
  );
};
